import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=012dd212&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=ts"
export * from "./NotificationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012dd212",
  null
  
)

export default component.exports